import { useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Projects from './components/Projects';
import Testimonials from './components/Testimonials';
import News from './components/News';
import CTA from './components/CTA';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function HomePage() {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
    const schema = {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'Organization',
          '@id': `${siteUrl}/#organization`,
          name: '株式会社永恒',
          url: siteUrl,
          logo: `${siteUrl}/vite.svg`,
          description: '千葉県市川市を拠点に、軽鉄下地LGS工事・ボード工事・壁紙クロス工事・床仕上工事を提供する内装仕上工事の専門会社。',
          telephone: '090-6002-2788',
          email: 'satomi102706@gmail.com',
          address: {
            '@type': 'PostalAddress',
            streetAddress: '二俣2-14-18',
            addressLocality: '市川市',
            addressRegion: '千葉県',
            addressCountry: 'JP',
          },
          openingHoursSpecification: [
            {
              '@type': 'OpeningHoursSpecification',
              dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
              opens: '09:00',
              closes: '18:00',
            },
          ],
          sameAs: [],
        },
        {
          '@type': 'WebSite',
          '@id': `${siteUrl}/#website`,
          url: siteUrl,
          name: '株式会社永恒',
          publisher: { '@id': `${siteUrl}/#organization` },
          inLanguage: 'ja',
        },
        {
          '@type': 'WebPage',
          '@id': `${siteUrl}/#webpage`,
          url: siteUrl,
          name: '株式会社永恒 | 軽鉄LGS・ボード・壁紙クロス・床仕上工事 千葉・東京',
          description: '千葉県市川市を拠点に、軽鉄下地LGS工事・ボード工事・壁紙クロス工事・床仕上工事を提供する内装仕上工事の専門会社。住宅・オフィス・商業施設・公共施設まで高品質な内装施工を実現します。',
          isPartOf: { '@id': `${siteUrl}/#website` },
          about: { '@id': `${siteUrl}/#organization` },
          inLanguage: 'ja',
        },
        {
          '@type': 'LocalBusiness',
          '@id': `${siteUrl}/#localbusiness`,
          name: '株式会社永恒',
          image: `${siteUrl}/vite.svg`,
          url: siteUrl,
          telephone: '090-6002-2788',
          email: 'satomi102706@gmail.com',
          address: {
            '@type': 'PostalAddress',
            streetAddress: '二俣2-14-18',
            addressLocality: '市川市',
            addressRegion: '千葉県',
            addressCountry: 'JP',
          },
          geo: {
            '@type': 'GeoCoordinates',
            latitude: 35.7219,
            longitude: 139.9311,
          },
          openingHoursSpecification: [
            {
              '@type': 'OpeningHoursSpecification',
              dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
              opens: '09:00',
              closes: '18:00',
            },
          ],
          priceRange: '¥¥',
          servesCuisine: undefined,
          hasOfferCatalog: {
            '@type': 'OfferCatalog',
            name: '内装仕上工事サービス',
            itemListElement: [
              { '@type': 'Offer', itemOffered: { '@type': 'Service', name: '軽鉄下地LGS工事' } },
              { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'ボード工事' } },
              { '@type': 'Offer', itemOffered: { '@type': 'Service', name: '壁紙クロス工事' } },
              { '@type': 'Offer', itemOffered: { '@type': 'Service', name: '床仕上工事' } },
            ],
          },
        },
      ],
    };

    const existingScript = document.getElementById('schema-home');
    if (existingScript) existingScript.remove();
    const script = document.createElement('script');
    script.id = 'schema-home';
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);

    return () => {
      const s = document.getElementById('schema-home');
      if (s) s.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <About />
      <Services />
      <Projects />
      <Testimonials />
      <News />
      <CTA />
      <Contact />
      <Footer />
    </div>
  );
}
